import { memo } from "react";

import { styled, Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";

import { getBaseInputContainerStyles, getSizeStyles } from "@/dashboard-design-system/BaseInput";

const WYSIWYG_SIDE_PASSING = 20;

export const useStyles = makeStyles(
  (theme) => ({
    simplykBottomMessage: {
      position: "absolute",
      bottom: theme.spacing(1),
      border: "none !important",
      backgroundColor: "white",
      zIndex: 1000000,
      paddingBottom: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingLeft: WYSIWYG_SIDE_PASSING,
      paddingRight: WYSIWYG_SIDE_PASSING,
      margin: 2,
      borderRadius: theme.radius(1),
    },
    linkSecondary: {
      color: theme.palette.secondary.main,
    },
    textCenter: {
      textAlign: "center",
    },
    hidden: {
      visibility: "hidden",
    },
    dialogContent: {
      padding: theme.spacing(8),
      paddingTop: theme.spacing(4),
    },
    link: {
      cursor: "pointer",
    },
    modalTitleDesktop: {
      textAlign: "center",
      ...theme.mixins.truncateOverflow,
    },
    modalTitleMobile: {
      textAlign: "center",
      ...theme.mixins.limitTextToNLines(3),
    },
    modalInformation: {
      marginLeft: theme.spacing(1),
    },
    "@global": {
      ".fr-toolbar.fr-top": {
        position: "sticky",
      },
    },
    progress: {
      marginTop: theme.spacing(3),
    },
    draftChipIcon: {
      fill: theme.palette.neutralVariant[20],
    },
    noMaxWidth: {
      maxWidth: "none",
    },
    modalBottomButtonWhenVerified: {
      [theme.breakpoints.down("sm")]: {
        maxHeight: 72,
      },
    },
    fullWidth: {
      width: "100%",
    },
    modalTitleContainer: {
      overflow: "hidden",
    },
    headerMobile: {
      position: "relative",
    },
    headerDesktop: {
      alignItems: "center",
      wrap: "nowrap",
      position: "relative",
    },
    draftLabel: {
      position: "absolute",
      bottom: 0,
      width: "100%",
    },
    displayContents: {
      display: "contents",
    },
    contactName: {
      textTransform: "capitalize",
    },
    contactList: {
      overflow: "hidden",
    },
    divider: {
      marginBottom: theme.spacing(2),
      width: "100%",
    },
    drawerContentContainer: {
      overflow: "hidden",
    },
    contentContainer: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      flexWrap: "nowrap",
    },
    tableContainer: {
      flex: 1,
      overflow: "hidden",
    },
    modalTitle: {
      textAlign: "center",
    },
    headerTitle: {
      padding: theme.spacing(2),
    },
    dividerContent: {
      color: theme.palette.neutralVariant[90],
    },
    wysiwyg: {
      height: "100%",
      overflowY: "auto",
      paddingBottom: theme.spacing(2),
    },
    chip: {
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(1),
      maxWidth: 220,
    },
  }),
  { index: 10 }
);

export const FixedEmailRecipientsInput = memo(
  styled("div")(({ theme }: { theme: Theme }) => ({
    disabled: true,
    pointerEvents: "none",
    display: "flex",
    flexWrap: "wrap",
    padding: theme.spacing(1, 1, 0, 0),
    maxHeight: 94,
    overflowY: "auto",
    ...getBaseInputContainerStyles("neutral", theme),
    backgroundColor: theme.palette.surface.neutral.moderate,
  }))
);

export const OrganizationNameWrapper = memo(
  styled("div")(({ theme }: { theme: Theme }) => ({
    disabled: true,
    pointerEvents: "none",
    width: "100%",
    ...theme.mixins.truncateOverflow,
    ...getBaseInputContainerStyles("neutral", theme),
    ...getSizeStyles("medium", theme),
  }))
);
